module.exports = __webpack_public_path__ + "static/paper-4d6606614ff1549799f51507b20f82ad.gif";